import { Platform } from '@round/api';

export function getSelectedPlatforms(
    tiktokBookingIds: number[] | undefined,
    instagramBookingIds: number[] | undefined
): Platform[] {
    let selectedPlatforms: Platform[] = [];
    if (tiktokBookingIds?.length) {
        selectedPlatforms.push('TIKTOK');
    }
    if (instagramBookingIds?.length) {
        selectedPlatforms.push('INSTAGRAM');
    }

    return selectedPlatforms;
}
